<template>
<div class="dialogPar">
  <el-form ref="form" label-width="45%" class="formMsg" :disabled="disabled" v-if="parType === '1'" v-loading="loading">
    <car-form :formItem="car"></car-form>
  </el-form>

  <el-form ref="form" label-width="45%" class="formMsg" :disabled="disabled" v-if="parType === '2' && typeOfpar2 === '1'">
    <carcopy-form :formItem="car_copy"></carcopy-form>
  </el-form>

  <el-form ref="form" label-width="45%" class="formMsg" :disabled="disabled" v-if="parType === '2' && typeOfpar2 === '2'">
    <two-wheel-form :formItem="twoWheel"></two-wheel-form>
  </el-form>

  <el-form ref="form" label-width="45%" class="formMsg" :disabled="disabled" v-if="parType === '2' && typeOfpar2 === '3'">
    <person-form :formItem="person"></person-form>
  </el-form>
</div>
</template>

<script>
import bus from './bus'
import arrayData from '../assets/javascript/dataProcess'
import carForm from '../assets/components/form'
import carcopyForm from '../assets/components/form'
import twoWheelForm from '../assets/components/form'
import personForm from '../assets/components/form'

export default {
  name: "dialogPar",
  components:{
    carForm,
    twoWheelForm,
    personForm,
    carcopyForm
  },
  data() {
    return {
      /*动画加载*/
      loading: false,
      /*是否可以编辑*/
      disabled: true,
      /*参与方二的种类*/
      typeOfpar2: '1',
      /*参与方的编号*/
      parType: '1',
      parData: [],
      car: [],
      car_copy: [],
      person: [],
      twoWheel: []
    }
  },
  methods: {
    /*数据渲染*/
    dataRender() {
      let carList = this.parData.carList;
      let twoWheel = this.parData.twoWheelVehicleList;
      let personList = this.parData.personList;
      if (carList.length > 1) {
        this.typeOfpar2 = '1';
        for (let i = 0; i < this.car.length; i++) {
          for (let key of Object.keys(carList[0])) {
            if (key === this.car[i].name) {
              this.car[i].value = carList[0][key];
            }
          }
        }
        for (let i = 0; i < this.car_copy.length; i++) {
          for (let key of Object.keys(carList[1])) {
            if (key === this.car_copy[i].name) {
              this.car_copy[i].value = carList[1][key];
            }
          }
        }
      } else {
        for (let i = 0; i < this.car.length; i++) {
          for (let key of Object.keys(carList[0])) {
            if (key === this.car[i].name) {
              this.car[i].value = carList[0][key];
            }
          }
        }
        if (twoWheel.length > 0) {
          this.typeOfpar2 = '2';
          for (let i = 0; i < this.twoWheel.length; i++) {
            for (let key of Object.keys(twoWheel[0])) {
              if (key === this.twoWheel[i].name) {
                this.twoWheel[i].value = twoWheel[0][key];
              }
            }
          }
        }
        if (personList.length > 0) {
          this.typeOfpar2 = '3';
          for (let i = 0; i < this.person.length; i++) {
            for (let key of Object.keys(personList[0])) {
              if (key === this.person[i].name) {
                this.person[i].value = personList[0][key];
              }
            }
          }
        }
      }
      /*发送参与方二的类型*/
      bus.$emit("par2Type", this.typeOfpar2);
    },
    /*获取要提交的值*/
    getValue(name) {
      let getData = {};
      for (let i = 0; i < name.length; i++) {
        let value = name[i].value;
        getData[name[i].name] = value;
      }
      return getData;
    },
    /*验证是否为空函数*/
    isNull(num, name) {
      for (let i = 0; i < num; i++) {
        if (name[i].value === "") {
          this.$set(name[i], "warning", 1);
          this.$set(name[i], "warningMsg", "必填信息不得为空");
        }
      }
    },
    /*发送要提交的值*/
    postValue(url, msg, value) {
      this.loading = true;
      this.$http.put(
          '/' + url + '/' + url,
          value, {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )
        .then((res) => {
          this.$message({
            message: msg + "修改成功",
            type: 'success',
            center: true,
            duration: 1000
          });
          this.$nextTick(
            this.loading = false,
          );
        })
        .catch((err) => {
          console.log(err);
          this.$nextTick(
            this.loading = false,
          );
        });
    },
    /*修改参与方一*/
    changePar1() {
      let formData = {};
      if (this.car[0].value === "" || this.car[1].value === "" || this.car[2].value === "") {
        this.isNull(3, this.car);
      } else {
        formData = this.getValue(this.car);
        formData.id = this.parData.carList[0].id;
        formData.totalId = this.parData.carList[0].totalId;
        formData.vehLength = this.parData.carList[0].vehLength;
        formData.vehWidth = this.parData.carList[0].vehWidth;
        formData.vehHight = this.parData.carList[0].vehHight;
        formData.weight = this.parData.carList[0].weight;
        formData.occFront = this.parData.carList[0].occFront;
        formData.occRear = this.parData.carList[0].occRear;
        formData.roofCargo = this.parData.carList[0].roofCargo;
        formData.trunkCargo = this.parData.carList[0].trunkCargo;
        formData.cogHeight = this.parData.carList[0].cogHeight;
        formData.cogAxle = this.parData.carList[0].cogAxle;
        formData.vehFrontoverhang = this.parData.carList[0].vehFrontoverhang;
        formData.vehShapeH3 = this.parData.carList[0].vehShapeH3;
        formData.wheelbase = this.parData.carList[0].wheelbase;
        formData.trackwidth1 = this.parData.carList[0].trackwidth1;
        formData.trackwidth2 = this.parData.carList[0].trackwidth2;
        formData.coeffFrict = this.parData.carList[0].coeffFrict;
        formData.momentRollL = this.parData.carList[0].momentRollL;
        formData.momentPitchL = this.parData.carList[0].momentPitchL;
        formData.momentYawL = this.parData.carList[0].momentYawL;
        this.postValue('car', '参与方信息一', formData);
      }
    },
    /*修改参与方二车*/
    changeCar() {
      let formData = {};
      if (this.car_copy[0].value === "" || this.car_copy[1].value === "" || this.car_copy[2].value === "") {
        this.isNull(3, this.car_copy);
      } else {
        formData = this.getValue(this.car_copy);
        formData.id = this.parData.carList[1].id;
        formData.totalId = this.parData.carList[1].totalId;
        formData.vehLength = this.parData.carList[1].vehLength;
        formData.vehWidth = this.parData.carList[1].vehWidth;
        formData.vehHight = this.parData.carList[1].vehHight;
        formData.weight = this.parData.carList[1].weight;
        formData.occFront = this.parData.carList[1].occFront;
        formData.occRear = this.parData.carList[1].occRear;
        formData.roofCargo = this.parData.carList[1].roofCargo;
        formData.trunkCargo = this.parData.carList[1].trunkCargo;
        formData.cogHeight = this.parData.carList[1].cogHeight;
        formData.cogAxle = this.parData.carList[1].cogAxle;
        formData.vehFrontoverhang = this.parData.carList[1].vehFrontoverhang;
        formData.vehShapeH3 = this.parData.carList[1].vehShapeH3;
        formData.wheelbase = this.parData.carList[1].wheelbase;
        formData.trackwidth1 = this.parData.carList[1].trackwidth1;
        formData.trackwidth2 = this.parData.carList[1].trackwidth2;
        formData.coeffFrict = this.parData.carList[1].coeffFrict;
        formData.momentRollL = this.parData.carList[1].momentRollL;
        formData.momentPitchL = this.parData.carList[1].momentPitchL;
        formData.momentYawL = this.parData.carList[1].momentYawL;
        this.postValue('car', '参与方信息二', formData);
      }
    },
    /*修改参与方二二轮车*/
    changeTwo() {
      let formData = {};
      if (this.twoWheel[0].value === "" || this.twoWheel[1].value === "" || this.twoWheel[2].value === "" || this.twoWheel[3].value === "" || this.twoWheel[4].value === "") {
        this.isNull(5, this.twoWheel)
      } else {
        formData = this.getValue(this.twoWheel);
        formData.id = this.parData.twoWheelVehicleList[0].id;
        formData.totalId = this.parData.twoWheelVehicleList[0].totalId;
        this.postValue('twowheelvehicle', '参与方信息二', formData);
      }
    },
    /*修改参与方二人*/
    changePerson() {
      let formData = {};
      if (this.person[0].value === "" || this.person[1].value === "" || this.person[2].value === "" || this.person[3].value === "" || this.person[4].value === "" || this.person[5].value === "") {
        this.isNull(6, this.person)
      } else {
        formData = this.getValue(this.person);
        formData.id = this.parData.personList[0].id;
        formData.totalId = this.parData.personList[0].totalId;
        this.postValue('person', '参与方信息二', formData);
      }
    }
  },
  created() {
    this.car = arrayData.data3.car;
    this.car_copy = arrayData.data3.car_copy;
    this.person = arrayData.data3.person;
    this.twoWheel = arrayData.data3.twoWheel;
    /*接收参与方编号*/
    bus.$on("parType", msg => {
      this.parType = msg;
    });
    /*可以编辑*/
    bus.$on("change", () => {
      this.disabled = false;
    });
    /*不可以修改*/
    bus.$on("disable", () => {
      this.disabled = true;
    });

    /*接收数据*/
    bus.$on("par", msg => {
      this.parData = msg;
      this.dataRender();
    });
    /*接收案例编号*/
    bus.$on("caseNumber", msg => {
      this.car[0].value = msg;
      this.car_copy[0].value = msg;
      this.person[0].value = msg;
      this.twoWheel[0].value = msg;
    })
  }
}
</script>

<style scoped>
.dialogPar {
  width: 99%;
  height: 100%;
}

.formMsg {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: flex-start;
}

</style>

<style>
.dialogPar .el-form-item__label {
  font-size: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/data/dialogPar.vue